var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10671 7.24634C6.04004 7.23967 5.96004 7.23967 5.88671 7.24634C4.30004 7.19301 3.04004 5.89301 3.04004 4.29301C3.04004 2.65967 4.36004 1.33301 6.00004 1.33301C7.63337 1.33301 8.96004 2.65967 8.96004 4.29301C8.95337 5.89301 7.69337 7.19301 6.10671 7.24634Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9402 2.66699C12.2335 2.66699 13.2735 3.71366 13.2735 5.00033C13.2735 6.26033 12.2735 7.28699 11.0268 7.33366C10.9735 7.32699 10.9135 7.32699 10.8535 7.33366",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77348 9.70699C1.16014 10.787 1.16014 12.547 2.77348 13.6203C4.60681 14.847 7.61348 14.847 9.44681 13.6203C11.0601 12.5403 11.0601 10.7803 9.44681 9.70699C7.62014 8.48699 4.61348 8.48699 2.77348 9.70699Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 13.333C12.7066 13.233 13.1599 13.0397 13.5332 12.753C14.5732 11.973 14.5732 10.6863 13.5332 9.90634C13.1666 9.62634 12.7199 9.43967 12.2466 9.33301",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d66b46f55a2b3555a23263514893ffea.svg";
export { ForwardRef as ReactComponent };